import React from 'react'
import PropTypes from 'prop-types'
import { Translation } from 'react-i18next'
import AssignmentRowContainer from '../../../containers/employer/assignments/assignmentRows.container'
import {
  Button,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  withStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core'
import NewAssignmentPreviewContainer from '../../../containers/employer/assignments/newAssignmentPreview.container'
import moment from 'moment'
import SnackbarComponent from '../../../utils/employer/snackbarComponent.utils'
import { scrollToTop } from '../../../utils/scrollTo'
import ExpandablePanel from '../../../utils/expandablePanel'
import ReactPaginate from 'react-paginate'
import mobileView from '../../../utils/mobile.utils'
import classNames from 'classnames'
import AssignmentForm from './assignmentForm.component'
import ContractFormDialog from '../../../utils/employer/contractFormDialog.utils'
import { resetForm, updateFormValues } from '../../../form'
import { useDispatch } from 'react-redux'
import {
  contractFormKeys,
  filterKeys,
  rearrangeByPinned
} from '../../../utils/openForWork.utils'
// import { applicantDataFormat } from '../applications/applicationRows.component'
import { employer_searchAssignments } from '../../../utils/openForWork.utils'
import { CloseIcon } from '../../openforwork/closeIcon.component'
import { AssignmentFilters } from '../../../utils/employer/assignment.utils'
import { useNavigationPrompt } from '../../../NavigationPromptProvider'

/**
 *
 * @author Huong Nguyen
 */

class AssignmentsComponent extends React.Component {
  componentDidMount() {
    this.props.getOfferFromLightEntre()
    this.props.getAreaOfWork()
    this.props.getFieldOfWork()
    this.props.getLightEntrepreneurs()
    this.props.getAssignments()
    this.props.getTotalApplications()
    this.props.getEmployerContractList()
    this.props.loadProfileStart()
    scrollToTop()
  }

  render() {
    return <Assignments {...this.props} />
  }
}

const styles = (theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },
  tablecell: {
    fontWeight: 'bold',
    fontSize: '13px',
    color: 'black'
  },
  tableHead: {
    fontSize: '13px',
    fontWeight: 'bold',
    borderBottom: '1px solid gray'
  },
  searchField: {
    display: 'flex',
    flexFlow: mobileView ? 'column' : 'row',
    justifyContent: 'space-between'
  },
  filterFields: {
    display: 'flex',
    flexFlow: mobileView ? 'column' : 'row',
    alignItems: mobileView ? 'stretch' : 'flex-end',
    padding: '0px 8px 30px'
  },
  buttonAdd: {
    marginRight: '15px',
    marginTop: '25px'
  },
  button: {
    margin: 15
  },
  textField: {
    marginTop: theme.spacing(3),
    border: '1px solid gray',
    fontSize: '14px'
  },
  resize: {
    fontSize: '15px'
  },
  checkbox: {
    fontSize: '15px',
    color: '#808080',
    fontWeight: 1000
  },
  table: {
    fontSize: '13px',
    borderTop: '2px solid #999'
  }
})

const defaultValues = {
  job_title: '',
  location: '',
  status: '',
  pageSize: 10,
  pinned: false
}

const statusOptions = [
  { value: '', label: '' },
  { value: 'draft', label: 'employer.assignmentStatus.draft' },
  { value: 'save', label: 'employer.assignmentStatus.save' },
  { value: 'pending', label: 'employer.assignmentStatus.pending' },
  // {
  //   value: 'Offer accepted by entrepreneur',
  //   label: 'employer.assignmentStatus.pending'
  // },
  {
    value: 'Offer rejected by entrepreneur',
    label: 'employer.assignmentStatus.Offer rejected by entrepreneur'
  },
  {
    value: 'Offer signed',
    label: 'employer.assignmentStatus.Offer signed'
  }
]

const Assignments = ({
  classes,
  assignmentList,
  enableSaveButton,
  previewNewAssignment,
  saveAssignmentUpdate,
  showPreview,
  addNewAssignment,
  isEdit,
  cancelEditAssignment,
  showSnackbarAdd,
  showSnackbarUpdate,
  showFailedSnackbar,
  closeAssignmentSnackbar,
  emailArray,
  saveAssignmentAsDraft,
  showDraftSnackbar,
  showFailedDraftSnackbar,
  showDeleteSnackbar,
  areaOfWork,
  openAssignmentForm,
  openAssignmentFormDialog,
  closeAssignmentFormDialog,
  offerFromLightEntre,
  offerToEntrepreneur,
  // showAskOfferContract,
  completeOfferForm,
  showContractOfferForm,
  copyPreviousAssignment,
  cancelOffer,
  openWarningCloseCompleteOfferForm,
  closeWarningCloseCompleteOfferForm,
  openWarningCloseCompleteForm,
  previewContract,
  // latestAssignmentData,
  showLeItemLoader,
  enableSendOrSignButton,
  signSendContract,
  loadSignAndSend,
  // selected
  // pageSize,
  // assignmentPageChange,
  showSnackbarSendOffer,
  showFailSnackbarSendOffer
}) => {
  const { confirmAction } = useNavigationPrompt()
  const dispatch = useDispatch()
  const [showAskOfferContract, setShowAskOfferContract] = React.useState(false)
  const [assignmentFormValues, setAssignmentFormValues] = React.useState(null)
  // Copy previous assignment agreement
  const [copyPrevious, setCopyPrevious] = React.useState(false)
  const [searchAssignmentValues, setSearchAssignmentValues] =
    React.useState(defaultValues)
  const [page, setPage] = React.useState(0)

  const filteredAssignmentRows = rearrangeByPinned(
    employer_searchAssignments(assignmentList, searchAssignmentValues).sort(
      (a, b) => b.assignment_id - a.assignment_id
    ),
    'pinned_assignment'
  )

  const handleSwitchChange = () => {
    setCopyPrevious((prevValue) => !prevValue)

    if (!copyPrevious) {
      copyPreviousAssignment()
    } else {
      dispatch(resetForm('contractForm'))
    }
  }
  // Take only needed keys to update contract form
  const latestAssignment = filterKeys(
    formatAssignmentValues(assignmentFormValues),
    contractFormKeys
  )

  React.useEffect(() => {
    if (showSnackbarAdd || showSnackbarSendOffer) {
      setShowAskOfferContract(false)
    }
  }, [showSnackbarAdd, showSnackbarSendOffer])
  return (
    <Translation>
      {(t) => {
        return (
          <>
            {/* <div className="container-big"> */}
            <div className="container">
              <div className="row">
                <div className="pull-right" style={{ paddingBottom: '15px' }}>
                  <Button
                    variant="contained"
                    className={classes.buttonAdd}
                    onClick={openAssignmentFormDialog}
                  >
                    {t('employer.assignments.h1b')}
                  </Button>
                </div>
              </div>
              <div className="row">
                <div className="dashboard-content-header">
                  <div className="col-xs-12 col-sm-12 col-lg-12">
                    <ExpandablePanel
                      title={t('employer.assignments.h3')}
                      renderBody={() => (
                        <div className={classes.root}>
                          <AssignmentFilters
                            t={t}
                            filters={searchAssignmentValues}
                            onChange={setSearchAssignmentValues}
                            classes={classes}
                            statusOptions={statusOptions}
                            resetSelectedPage={() => setPage(0)}
                          />
                          <Table
                            className={classes.table}
                            aria-labelledby="tableTitle"
                            aria-label="enhanced table"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell className={classes.tableHead}>
                                  {t('employer.assignments.col1')}
                                </TableCell>
                                <TableCell
                                  className={classNames(
                                    classes.tableHead,
                                    'hide-mobile'
                                  )}
                                >
                                  {t('employer.assignments.col3')}
                                </TableCell>
                                <TableCell
                                  className={classNames(
                                    classes.tableHead,
                                    'hide-mobile'
                                  )}
                                >
                                  {t('employer.assignments.col7')}
                                </TableCell>
                                <TableCell className={classes.tableHead}>
                                  {t('employer.assignments.label12a')}
                                </TableCell>
                                <TableCell className={classes.tableHead}>
                                  {t('employer.assignments.status')}
                                </TableCell>
                                <TableCell
                                  className={classes.tableHead}
                                ></TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {createAssignmentRows(
                                t,
                                page,
                                searchAssignmentValues.pageSize,
                                filteredAssignmentRows,
                                emailArray
                              )}
                            </TableBody>
                          </Table>
                          <Divider />
                          <div className="panel-body">
                            {filteredAssignmentRows.length > 0 ? (
                              <ReactPaginate
                                previousLabel={
                                  <i className="fa fa-chevron-left" />
                                }
                                nextLabel={
                                  <i className="fa fa-chevron-right" />
                                }
                                breakLabel={'...'}
                                breakClassName={'break-me'}
                                pageCount={
                                  !!filteredAssignmentRows
                                    ? Math.ceil(
                                        filteredAssignmentRows.length /
                                          searchAssignmentValues.pageSize
                                      )
                                    : 0
                                }
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={(event) => {
                                  setPage(event.selected)
                                }}
                                containerClassName={'pagination'}
                                subContainerClassName={'pages pagination'}
                                activeClassName={'active'}
                                forcePage={page}
                              />
                            ) : (
                              <div style={{ padding: '20px' }}></div>
                            )}
                          </div>
                        </div>
                      )}
                      defaultExpanded={true}
                    />
                  </div>
                </div>
              </div>
            </div>
            <Dialog
              open={openAssignmentForm || offerFromLightEntre}
              fullWidth
              maxWidth="lg"
              // onClose={closeAssignmentFormDialog}
            >
              <CloseIcon
                fontSize="large"
                onClick={() => {
                  confirmAction('', () => {
                    closeAssignmentFormDialog()
                    setShowAskOfferContract(false)
                    cancelEditAssignment()
                  })
                }}
              />
              <DialogContent>
                <AssignmentForm
                  isEdit={isEdit}
                  areaOfWork={areaOfWork}
                  emailArray={emailArray}
                  enableSaveButton={enableSaveButton}
                  previewNewAssignment={previewNewAssignment}
                  addNewAssignment={addNewAssignment}
                  // cancelEditAssignment={cancelEditAssignment}
                  saveAssignmentAsDraft={saveAssignmentAsDraft}
                  saveAssignmentUpdate={saveAssignmentUpdate}
                  closeAssignmentFormDialog={closeAssignmentFormDialog}
                  formPlaced="/dashboard/assignments"
                  offerFromLightEntre={offerFromLightEntre}
                  offerToEntrepreneur={offerToEntrepreneur}
                  showAskOfferContract={showAskOfferContract}
                  setShowAskOfferContract={setShowAskOfferContract}
                  setAssignmentFormValues={setAssignmentFormValues}
                />
              </DialogContent>
            </Dialog>
            <Dialog
              open={showPreview}
              fullWidth
              maxWidth="md"
              aria-describedby="alert-dialog-description"
            >
              <DialogContent id="alert-dialog-description">
                <NewAssignmentPreviewContainer emails={emailArray} />
              </DialogContent>
            </Dialog>
            {/*Show dialog after add assignment to offer contract from Light Entrepreneurs page*/}
            <Dialog
              open={showAskOfferContract && offerFromLightEntre}
              fullWidth
              maxWidth="md"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                <span style={{ fontSize: '20px' }}>
                  {t('employer.assignments.dialogTitle2')}
                </span>
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <span style={{ fontSize: '14px' }}>
                    {t('employer.assignments.dialogSubTitle2')}
                  </span>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <div className="pull-right">
                  <Button
                    variant="outlined"
                    className={classes.dialogButton}
                    onClick={() => {
                      setShowAskOfferContract(false)
                    }}
                  >
                    {t('employer.assignments.btn9')}
                  </Button>
                  <Button
                    variant="outlined"
                    className={classes.dialogButton}
                    onClick={() => {
                      addNewAssignment(assignmentFormValues, false)
                    }}
                  >
                    {t('employer.assignments.btn10')}
                  </Button>
                  <Button
                    variant="contained"
                    className={classes.dialogButton}
                    onClick={() => {
                      completeOfferForm(offerToEntrepreneur)
                      if (offerFromLightEntre) {
                        dispatch(
                          updateFormValues('contractForm', latestAssignment)
                        )
                      }
                      setShowAskOfferContract(false)
                    }}
                  >
                    {t('employer.assignments.btn6')}
                  </Button>
                </div>
              </DialogActions>
            </Dialog>
            <ContractFormDialog
              classes={classes}
              t={t}
              isOpen={showContractOfferForm}
              title={t('employer.app.dialogTitle1')}
              subtitle={t('employer.lightEntrepreneurs.label4')}
              copyPrevious={copyPrevious}
              handleSwitchChange={handleSwitchChange}
              cancelOffer={cancelOffer}
              formSubmit={previewContract}
              setCopyPrevious={setCopyPrevious}
              openWarningCloseCompleteOfferForm={
                openWarningCloseCompleteOfferForm
              }
              closeWarningCloseCompleteOfferForm={
                closeWarningCloseCompleteOfferForm
              }
              openWarningCloseCompleteForm={openWarningCloseCompleteForm}
              formLocation="/dashboard/assignments"
              showLeItemLoader={showLeItemLoader}
              signAndSendContract={signSendContract}
              enableSendOrSignButton={enableSendOrSignButton}
              loadSignAndSend={loadSignAndSend}
              assignmentFormValues={assignmentFormValues}
              addNewAssignment={addNewAssignment}
              offerFromLightEntre={offerFromLightEntre}
            />
            <SnackbarComponent
              open={showSnackbarAdd && !offerFromLightEntre}
              message={t('employer.assignments.msg1')}
              variant="success"
              autoHideDuration={3000}
              onClose={closeAssignmentSnackbar}
            />
            <SnackbarComponent
              open={showSnackbarUpdate}
              message={t('employer.assignments.msg2')}
              variant="success"
              autoHideDuration={3000}
              onClose={closeAssignmentSnackbar}
            />
            <SnackbarComponent
              open={showFailedSnackbar}
              message={t('employer.assignments.msg3')}
              variant="error"
              autoHideDuration={3000}
              onClose={closeAssignmentSnackbar}
            />
            {/* Draft */}
            <SnackbarComponent
              open={showDraftSnackbar}
              message={t('employer.assignments.msg4')}
              variant="success"
              autoHideDuration={3000}
              onClose={closeAssignmentSnackbar}
            />
            <SnackbarComponent
              open={showFailedDraftSnackbar}
              message={t('employer.assignments.msg5')}
              variant="error"
              autoHideDuration={3000}
              onClose={closeAssignmentSnackbar}
            />
            {/* Delete */}
            <SnackbarComponent
              open={showDeleteSnackbar}
              message={t('employer.assignments.msg6')}
              variant="success"
              autoHideDuration={3000}
              onClose={closeAssignmentSnackbar}
            />
            <SnackbarComponent
              open={showSnackbarSendOffer}
              message={t('employer.app.msg1')}
              variant="success"
              autoHideDuration={3000}
              onClose={closeAssignmentSnackbar}
            />
            <SnackbarComponent
              open={showFailSnackbarSendOffer}
              message={t('employer.app.msg2')}
              variant="error"
              autoHideDuration={3000}
              onClose={closeAssignmentSnackbar}
            />
          </>
        )
      }}
    </Translation>
  )
}

const createAssignmentRows = (
  t,
  selected,
  pageSize,
  assignmentsRows,
  lightEntreList
) => {
  return assignmentsRows
    .slice(selected * pageSize, selected * pageSize + pageSize)
    .map((el, index) => (
      <AssignmentRowContainer
        t={t}
        index={index}
        assignmentData={el}
        key={el.assignment_id}
        job_title={el.job_title}
        industryType={el.industry_type}
        location={el.location}
        assignment_type={el.assignment_type}
        last_date_of_application={moment(el.last_date_of_application).format(
          'DD.MM.YYYY'
        )}
        salary_model={el.salary_model}
        assignment_begin={moment(el.assignment_begins).format('DD.MM.YYYY')}
        enterpreneur_email={el.enterpreneur_email} // Offer to email
        status={
          el?.status_assignment
            ? el.status_assignment
            : el.agreement_status_entrepreneur
        }
        assignment_id={el.assignment_id}
        pinned_assignment={el.pinned_assignment}
        lightEntreList={lightEntreList}
      />
    ))
}

const formatAssignmentValues = (values) => {
  const formValues = { ...values }
  formValues.content_assignment = formValues.job_des
  formValues.salary_model = formValues.salaryModel
  formValues.assignment_type = formValues.assignmentType
  const salary_model = formValues.salaryModel
  const assignment_type = formValues.assignmentType
  if (
    salary_model === 'hourly_rate' ||
    (salary_model === 'commission' && assignment_type === 'until_completion')
  ) {
    formValues.amount = formValues.hourlyRate
  } else if (
    salary_model === 'contract_price' &&
    (assignment_type === 'temporary_with_notice' ||
      assignment_type === 'until_completion')
  ) {
    formValues.amount = formValues.contractSalary
  } else if (
    salary_model === 'unit_price' &&
    (assignment_type === 'temporary_with_notice' ||
      assignment_type === 'until_completion')
  ) {
    formValues.amount = formValues.unitPrice
  } else formValues.amount = formValues.amount_e
  formValues.assignment_begins = formValues.assignmentBegin
  formValues.assignment_ends =
    formValues.assignmentType === 'temporary'
      ? formValues?.assignmentEnds
      : null
  formValues.payment_terms = 14 // Default value
  formValues.isExpensesIncluded = 'no' // Default value
  formValues.additional_terms = '' // Default value
  formValues.eng_lang = false // Default value
  return formValues
}

AssignmentsComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(AssignmentsComponent)
